"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- RADIO : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'Radio',
  group: _definitionhelpers.groupNames.switches,
  props: {
    name: {
      type: 'string'
    },
    title: {
      type: 'object'
    },
    color: {
      type: 'string',
      default: 'primary',
      options: ['system', 'primary', 'secondary', 'supporting', 'accent', 'compliment', 'warning', 'attention', 'neutral', 'light', 'dark', 'grey']
    },
    handleChange: {
      type: 'function',
      default: function _default(e) {
        return console.log('radio selected: ', e.target.value);
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    },
    isList: {
      type: 'boolean',
      options: [true, false],
      default: true
    },
    checked: {
      type: 'boolean',
      options: [true, false]
    },
    value: {
      type: 'string'
    },
    disabled: {
      type: 'boolean',
      options: [true, false]
    }
  }
};
exports.default = _default2;